import React from 'react';

import {Platform, TouchableOpacity, View} from 'react-native';

import {BodyText} from 'src/Modules/CommonView';

import CarouselView from 'src/Modules/CommonView/CarouselView';

export const HeaderAndCarouselView = ({
  buttonPress = {},
  buttonText,
  title = '',
  subTitle,
  data,
  type = '',

  cardPress, // optional override
  hideIfNoData = false,
  onFocus = false,
  showStars = false,
  extraMargin = false,
  carouselIndex,
  intialMaxLength = 10,
}) => {
  return (
    <View style={{flex: 1}}>
      <View style={{position: 'relative'}}>
        <BodyText
          text={title}
          textStyle={{
            marginTop: 20,
            fontWeight: '700',
            marginBottom: Platform.OS == 'web' ? 30 : 0,
          }}
        />

        {!!buttonText && (
          <TouchableOpacity
            style={{
              position: 'absolute',
              bottom: -4,
              right: 0,
              paddingBottom: 3,
              height: 30,
            }}
            onPress={buttonPress}>
            <BodyText
              text={buttonText}
              textStyle={{
                color: global?.color?.blue,
                fontWeight: '700',
                fontSize: 14,
              }}
            />
          </TouchableOpacity>
        )}
      </View>
      {!!subTitle && data?.length > 0 && (
        <BodyText text={subTitle} textStyle={{marginTop: 5}} />
      )}
      {!!data && (
        <CarouselView
          data={data}
          extraMargin={extraMargin}
          nav
          cardPress={cardPress}
          type={type}
          hideIfNoData={hideIfNoData}
          onFocus={onFocus}
          showStars={showStars}
          carouselIndex={carouselIndex}
          intialMaxLength={intialMaxLength}
        />
      )}
    </View>
  );
};
